/**
 * The confirmation sheet used before anything that throws work away or passes
 * judgment on it — a new exercise over a written line, and grading.
 *
 * Both of those are deliberate moments in this app rather than incidental
 * clicks, which is why they ask.
 */

import type { JSX } from 'react';
import { Modal } from './Modal';

export interface ConfirmRequest {
  title: string;
  body: string;
  /** Label for the button that goes ahead. */
  confirmLabel: string;
  /** Renders the confirm button in the warning colour. */
  destructive?: boolean;
  onConfirm: () => void;
}

export function ConfirmDialog({
  request,
  onDismiss,
}: {
  request: ConfirmRequest | null;
  onDismiss: () => void;
}): JSX.Element {
  return (
    <Modal
      open={request != null}
      title={request?.title ?? ''}
      onClose={onDismiss}
      footer={
        <>
          <button type="button" className="button" onClick={onDismiss}>
            Cancel
          </button>
          <button
            type="button"
            className={request?.destructive ? 'button button--primary button--danger' : 'button button--primary'}
            onClick={() => {
              request?.onConfirm();
              onDismiss();
            }}
            data-autofocus
          >
            {request?.confirmLabel ?? 'OK'}
          </button>
        </>
      }
    >
      <p>{request?.body}</p>
    </Modal>
  );
}
